import * as C from "react";
import { useEffect as y, useRef as $, useReducer as U, useState as v, createContext as V, useContext as P, useMemo as E } from "react";
import { P as c, u as b } from "./useGetSubdivisionType-CuJXxyQE.js";
import { S as We, i as Ge, j as Ye, a as Je, b as Be, k as Xe, q as Ze, l as ze, c as De, f as et, g as tt, d as nt, e as st, m as rt, n as ot, o as ut, p as it, h as ct } from "./useGetSubdivisionType-CuJXxyQE.js";
import { g as F } from "./tailwind-BXrsiEcF.js";
function we(e = 0) {
  const [n, t] = C.useState(!1);
  return C.useEffect(() => {
    const s = () => {
      t(
        window.innerHeight + window.scrollY >= document.body.offsetHeight - e
      );
    };
    return window.addEventListener("scroll", s, { passive: !0 }), s(), () => {
      window.removeEventListener("scroll", s);
    };
  }, [e]), n;
}
function ve({
  timeout: e = 2e3
}) {
  const [n, t] = C.useState(!1);
  return { isCopied: n, copyToClipboard: (r) => {
    var o;
    typeof window > "u" || !((o = navigator.clipboard) != null && o.writeText) || r && navigator.clipboard.writeText(r).then(() => {
      t(!0), setTimeout(() => {
        t(!1);
      }, e);
    });
  } };
}
function xe(e) {
  y(() => {
    document.title = e;
  }, [e]);
}
function Ee() {
  const e = $(null);
  return { formRef: e, onKeyDown: (t) => {
    var s;
    t.key === "Enter" && !t.shiftKey && !t.nativeEvent.isComposing && ((s = e.current) == null || s.requestSubmit(), t.preventDefault());
  } };
}
function Le() {
  const [e, n] = U((t) => t + 1, 0);
  return n;
}
function Re() {
  const [e, n] = v(() => {
    var t;
    return !!((t = window.django) != null && t.reactInterpolate);
  });
  return y(() => {
    const s = setInterval(() => {
      var i;
      const o = !!((i = window.django) != null && i.reactInterpolate);
      o !== e && n(o);
    }, 50), r = new MutationObserver((o) => {
      o.forEach((i) => {
        i.type === "childList" && i.removedNodes.forEach((f) => {
          f.nodeType === Node.ELEMENT_NODE && f.tagName === "SCRIPT" && f.id === "gettext-translations" && n(!1);
        });
      });
    });
    return r.observe(document.head, { childList: !0 }), () => {
      clearInterval(s), r.disconnect();
    };
  }, [e]), e;
}
const Ie = (e, n) => {
  const [t, s] = v(n);
  return y(() => {
    const o = window.localStorage.getItem(e);
    o && s(JSON.parse(o));
  }, [e]), [t, (o) => {
    s(o), window.localStorage.setItem(e, JSON.stringify(o));
  }];
};
var S = {}, O;
function H() {
  if (O) return S;
  O = 1, S.match = o, S.parse = i;
  var e = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i, n = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/, t = /^(?:(min|max)-)?(.+)/, s = /(em|rem|px|cm|mm|in|pt|pc)?$/, r = /(dpi|dpcm|dppx)?$/;
  function o(d, a) {
    return i(d).some(function(l) {
      var h = l.inverse, L = l.type === "all" || a.type === l.type;
      if (L && h || !(L || h))
        return !1;
      var x = l.expressions.every(function(g) {
        var R = g.feature, I = g.modifier, p = g.value, _ = a[R];
        if (!_)
          return !1;
        switch (R) {
          case "orientation":
          case "scan":
            return _.toLowerCase() === p.toLowerCase();
          case "width":
          case "height":
          case "device-width":
          case "device-height":
            p = w(p), _ = w(_);
            break;
          case "resolution":
            p = u(p), _ = u(_);
            break;
          case "aspect-ratio":
          case "device-aspect-ratio":
          case /* Deprecated */
          "device-pixel-ratio":
            p = f(p), _ = f(_);
            break;
          case "grid":
          case "color":
          case "color-index":
          case "monochrome":
            p = parseInt(p, 10) || 1, _ = parseInt(_, 10) || 0;
            break;
        }
        switch (I) {
          case "min":
            return _ >= p;
          case "max":
            return _ <= p;
          default:
            return _ === p;
        }
      });
      return x && !h || !x && h;
    });
  }
  function i(d) {
    return d.split(",").map(function(a) {
      a = a.trim();
      var l = a.match(e), h = l[1], L = l[2], x = l[3] || "", g = {};
      return g.inverse = !!h && h.toLowerCase() === "not", g.type = L ? L.toLowerCase() : "all", x = x.match(/\([^\)]+\)/g) || [], g.expressions = x.map(function(R) {
        var I = R.match(n), p = I[1].toLowerCase().match(t);
        return {
          modifier: p[1],
          feature: p[2],
          value: I[2]
        };
      }), g;
    });
  }
  function f(d) {
    var a = Number(d), l;
    return a || (l = d.match(/^(\d+)\s*\/\s*(\d+)$/), a = l[1] / l[2]), a;
  }
  function u(d) {
    var a = parseFloat(d), l = String(d).match(r)[1];
    switch (l) {
      case "dpcm":
        return a / 2.54;
      case "dppx":
        return a * 96;
      default:
        return a;
    }
  }
  function w(d) {
    var a = parseFloat(d), l = String(d).match(s)[1];
    switch (l) {
      case "em":
        return a * 16;
      case "rem":
        return a * 16;
      case "cm":
        return a * 96 / 2.54;
      case "mm":
        return a * 96 / 2.54 / 10;
      case "in":
        return a * 96;
      case "pt":
        return a * 72;
      case "pc":
        return a * 72 / 12;
      default:
        return a;
    }
  }
  return S;
}
var M, q;
function Q() {
  if (q) return M;
  q = 1;
  var e = H().match, n = typeof window < "u" ? window.matchMedia : null;
  function t(r, o, i) {
    var f = this, u;
    n && !i && (u = n.call(window, r)), u ? (this.matches = u.matches, this.media = u.media, u.addListener(a)) : (this.matches = e(r, o), this.media = r), this.addListener = w, this.removeListener = d, this.dispose = l;
    function w(h) {
      u && u.addListener(h);
    }
    function d(h) {
      u && u.removeListener(h);
    }
    function a(h) {
      f.matches = h.matches, f.media = h.media;
    }
    function l() {
      u && u.removeListener(a);
    }
  }
  function s(r, o, i) {
    return new t(r, o, i);
  }
  return M = s, M;
}
var K = Q();
const W = /* @__PURE__ */ F(K);
var G = /[A-Z]/g, Y = /^ms-/, T = {};
function J(e) {
  return "-" + e.toLowerCase();
}
function j(e) {
  if (T.hasOwnProperty(e))
    return T[e];
  var n = e.replace(G, J);
  return T[e] = Y.test(n) ? "-" + n : n;
}
function B(e, n) {
  if (e === n)
    return !0;
  if (!e || !n)
    return !1;
  const t = Object.keys(e), s = Object.keys(n), r = t.length;
  if (s.length !== r)
    return !1;
  for (let o = 0; o < r; o++) {
    const i = t[o];
    if (e[i] !== n[i] || !Object.prototype.hasOwnProperty.call(n, i))
      return !1;
  }
  return !0;
}
const m = c.oneOfType([c.string, c.number]), k = {
  all: c.bool,
  grid: c.bool,
  aural: c.bool,
  braille: c.bool,
  handheld: c.bool,
  print: c.bool,
  projection: c.bool,
  screen: c.bool,
  tty: c.bool,
  tv: c.bool,
  embossed: c.bool
}, X = {
  orientation: c.oneOf(["portrait", "landscape"]),
  scan: c.oneOf(["progressive", "interlace"]),
  aspectRatio: c.string,
  deviceAspectRatio: c.string,
  height: m,
  deviceHeight: m,
  width: m,
  deviceWidth: m,
  color: c.bool,
  colorIndex: c.bool,
  monochrome: c.bool,
  resolution: m,
  type: Object.keys(k)
}, { type: Se, ...Z } = X, z = {
  minAspectRatio: c.string,
  maxAspectRatio: c.string,
  minDeviceAspectRatio: c.string,
  maxDeviceAspectRatio: c.string,
  minHeight: m,
  maxHeight: m,
  minDeviceHeight: m,
  maxDeviceHeight: m,
  minWidth: m,
  maxWidth: m,
  minDeviceWidth: m,
  maxDeviceWidth: m,
  minColor: c.number,
  maxColor: c.number,
  minColorIndex: c.number,
  maxColorIndex: c.number,
  minMonochrome: c.number,
  maxMonochrome: c.number,
  minResolution: m,
  maxResolution: m,
  ...Z
}, D = { ...k, ...z };
var ee = {
  all: D
};
const te = (e) => `not ${e}`, ne = (e, n) => {
  const t = j(e);
  return typeof n == "number" && (n = `${n}px`), n === !0 ? t : n === !1 ? te(t) : `(${t}: ${n})`;
}, se = (e) => e.join(" and "), re = (e) => {
  const n = [];
  return Object.keys(ee.all).forEach((t) => {
    const s = e[t];
    s != null && n.push(ne(t, s));
  }), se(n);
}, oe = V(void 0), ue = (e) => e.query || re(e), N = (e) => e ? Object.keys(e).reduce((t, s) => (t[j(s)] = e[s], t), {}) : void 0, A = () => {
  const e = $(!1);
  return y(() => {
    e.current = !0;
  }, []), e.current;
}, ie = (e) => {
  const n = P(oe), t = () => N(e) || N(n), [s, r] = v(t);
  return y(() => {
    const o = t();
    B(s, o) || r(o);
  }, [e, n]), s;
}, ce = (e) => {
  const n = () => ue(e), [t, s] = v(n);
  return y(() => {
    const r = n();
    t !== r && s(r);
  }, [e]), t;
}, ae = (e, n) => {
  const t = () => W(e, n || {}, !!n), [s, r] = v(t), o = A();
  return y(() => {
    if (o) {
      const i = t();
      return r(i), () => {
        i && i.dispose();
      };
    }
  }, [e, n]), s;
}, le = (e) => {
  const [n, t] = v(e.matches);
  return y(() => {
    const s = (r) => {
      t(r.matches);
    };
    return e.addListener(s), t(e.matches), () => {
      e.removeListener(s);
    };
  }, [e]), n;
}, be = (e, n, t) => {
  const s = ie(n), r = ce(e);
  if (!r)
    throw new Error("Invalid or missing MediaQuery!");
  const o = ae(r, s), i = le(o), f = A();
  return y(() => {
    f && t && t(i);
  }, [i]), y(() => () => {
    o && o.dispose();
  }, []), i;
};
function Me({ belowThreshold: e }) {
  const [n, t] = v(!1);
  return y(() => {
    const s = () => {
      window.scrollY > e ? t(!0) : t(!1);
    };
    return window.addEventListener("scroll", s), s(), () => {
      window.removeEventListener("scroll", s);
    };
  }, [e]), { isBelowThreshold: n };
}
function Te(e) {
  return E(() => {
    if (e) {
      const n = new Intl.Locale(e);
      let t;
      return "getTextInfo" in n && typeof n.getTextInfo == "function" ? t = n.getTextInfo() : "textInfo" in n && (t = n.textInfo), (t == null ? void 0 : t.direction) === "rtl";
    }
    return !1;
  }, [e]);
}
function Ce(e, n, t) {
  const { getConfig: s } = b({
    conversation: e,
    noticeboardData: n,
    useSystemLanguage: !0
  }), r = s(`${t}.existing_land_use_term`);
  if (r != null && r.expert_name) {
    const o = r.parsedOutput;
    if (!o || typeof o != "object") return [];
    const i = Object.keys(o).filter(
      (u) => u === "existing_land_use_term" || /^existing_land_use_term_([1-9]$)/.test(u)
    );
    if (i.length === 0) {
      const { content: u } = s(
        `${t}.existing_land_use_term`
      );
      return u ? [u] : [];
    }
    return i.map((u) => o[u]).filter((u) => !!u);
  }
  return [];
}
function Oe(e, n, t) {
  const { getConfig: s } = b({
    conversation: e,
    noticeboardData: n,
    useSystemLanguage: !0
  }), { content: r } = s(
    `${t}.proposed_land_use_term`
  );
  return r || "";
}
function qe(e, n, t) {
  const { getConfig: s } = b({
    conversation: e,
    noticeboardData: n,
    useSystemLanguage: !0
  }), r = s(`${t}.proposed_land_use_term`);
  if (r != null && r.expert_name) {
    const o = r.parsedOutput;
    if (!o || typeof o != "object") return [];
    const i = Object.keys(o).filter(
      (u) => u === "proposed_land_use_term" || /^proposed_land_use_term_([1-9]$)/.test(u)
    );
    if (i.length === 0) {
      const { content: u } = s(
        `${t}.proposed_land_use_term`
      );
      return u ? [u] : [];
    }
    return i.map((u) => o[u]).filter(
      (u) => !!u && u.toUpperCase() !== "N/A"
    );
  }
  return [];
}
function Ne(e, n, t) {
  var o;
  const { getConfig: s } = b({
    conversation: e,
    noticeboardData: n,
    useSystemLanguage: !0
  }), r = s(`${t}.project_details`);
  return {
    ...r,
    expert_name: r.name || "project_details",
    content: r.name ? r.content || "" : ((o = n == null ? void 0 : n.project_details) == null ? void 0 : o.raw_output) || ""
  };
}
function fe(e, n) {
  return E(() => ({ ...e != null && e.frontend_expert_output_config ? structuredClone(
    e == null ? void 0 : e.frontend_expert_output_config
  ) : void 0, ...n }), [e == null ? void 0 : e.frontend_expert_output_config, n]);
}
const de = void 0;
function $e(e, n) {
  if (!e) return !1;
  if (["dev", "dojo"].includes(de)) return !0;
  const t = e.frontend_expert_output_config, s = t == null ? void 0 : t[n], r = s == null ? void 0 : s.enable_application_requirements;
  if (typeof r == "boolean")
    return r;
  if (typeof r == "object")
    return r.enabled ? r.councils.includes(
      e.council_code || ""
    ) : !1;
}
const pe = void 0;
function je(e, n) {
  if (!e) return !1;
  if (["dev", "dojo"].includes(pe)) return !0;
  const t = e.frontend_expert_output_config, s = t == null ? void 0 : t[n];
  return !!(s != null && s.enable_missing_information);
}
const me = void 0;
function ke(e, n) {
  if (!e) return !1;
  if (["dev", "dojo"].includes(me)) return !0;
  const t = e.frontend_expert_output_config, s = t == null ? void 0 : t[n];
  return !!(s != null && s.enable_vic_smart);
}
const he = void 0;
function Ae(e, n) {
  if (!e) return !1;
  if (["dev", "dojo"].includes(he)) return !0;
  const t = e.frontend_expert_output_config, s = t == null ? void 0 : t[n];
  return !!(s != null && s.enable_vicsmart_standard_app_requirements);
}
function Ue(e) {
  const { messageType: n, messages: t } = e;
  return E(() => t == null ? void 0 : t.find((s) => s.message_type === n), [n, t]);
}
function Ve({
  conversation: e,
  noticeboardData: n
}) {
  const t = fe(e), s = t == null ? void 0 : t.enquiry;
  return E(() => {
    var i, f, u, w;
    const { expert_name: r = "", output_key: o = "" } = (s == null ? void 0 : s.missing_information_questions) || {};
    return (f = (i = n == null ? void 0 : n[r]) == null ? void 0 : i.parsed_output) != null && f[o] ? (((w = (u = n == null ? void 0 : n[r]) == null ? void 0 : u.parsed_output) == null ? void 0 : w[o]) || []).map((a, l) => ({
      id: `${l}-${a.clause_number}`,
      question: a.exemption_text
    })) : [];
  }, [s, n]);
}
function Pe(e) {
  var n, t;
  return (n = e == null ? void 0 : e.reiteration) != null && n.raw_output ? (t = e == null ? void 0 : e.reiteration) == null ? void 0 : t.raw_output : "";
}
function Fe(e, n) {
  return E(() => e && n ? e : e == null ? void 0 : e.map((t) => ({
    ...t,
    text: t.system_language_text || t.text
  })), [e, n]);
}
function He(e, n) {
  return E(() => {
    if (e && n)
      return e;
    if (e) {
      const t = {};
      for (const [s, r] of Object.entries(e))
        t[s] = {
          ...r,
          raw_output: r.system_language_raw_output ?? r.raw_output,
          parsed_output: r.system_language_parsed_output ?? r.parsed_output
        };
      return t;
    }
  }, [e, n]);
}
export {
  oe as Context,
  We as SubdivisionType,
  re as toQuery,
  Ge as useAssessmentLights,
  we as useAtBottom,
  ve as useCopyToClipboard,
  Ye as useCouncilLocalisation,
  Je as useDebounce,
  xe as useDocumentTitle,
  Be as useDragScroll,
  Ee as useEnterSubmit,
  Ce as useExistingLandUses,
  fe as useExpertMapConfig,
  Xe as useFindAllMessageOfType,
  Ue as useFindMessageOfType,
  Le as useForceRerender,
  b as useGetReportContent,
  Ze as useGetSubdivisionType,
  ze as useHasRevisions,
  Re as useI18nReady,
  De as useInitMultiLingual,
  $e as useIsApplicationRequirementsEnabled,
  et as useIsDetailedAnalysisEnabled,
  tt as useIsFollowUpFlowEnabled,
  je as useIsMissingInformationEnabled,
  nt as useIsMobile,
  st as useIsRTL,
  rt as useIsReportFinalised,
  ot as useIsReportLocked,
  ke as useIsVicSmartEnabled,
  Ae as useIsVicSmartStandardApplicationRequirementsEnabled,
  ut as useLatestMessage,
  Ie as useLocalStorage,
  be as useMediaQuery,
  Ve as useMissingInformationQuestions,
  it as useParsedReviews,
  Ne as useProjectDetails,
  Oe as useProposedLandUse,
  qe as useProposedLandUses,
  Pe as useReiterationExpert,
  Me as useScrollTracking,
  Te as useShouldShowRTL,
  ct as useShowVicSmartSection,
  Fe as useTranslateMessages,
  He as useTranslateNoticeboard
};
//# sourceMappingURL=hooks.js.map
